import { createBrowserRouter, type RouteObject } from "react-router-dom";
import { AppShell } from "./components/layout/AppShell";
import { Page } from "./components/layout/Page";
import { EmptyState } from "./components/ui/ErrorState";
import { ButtonLink } from "./components/ui/Button";
import { Login } from "./pages/Login";
import { Home } from "./pages/Home";
import { Squad } from "./pages/Squad";
import { Market } from "./pages/Market";
import { Player } from "./pages/Player";
import { Recommend } from "./pages/Recommend";
import { Lineup } from "./pages/Lineup";
import { Settings } from "./pages/Settings";

/** Dirección que no existe. Dice qué pasó y ofrece la única salida útil: volver a Inicio. */
function NotFound() {
  return (
    <Page title="No encontrado">
      <EmptyState
        title="Esa dirección no existe"
        message="Puede que el enlace esté mal escrito o que la pantalla haya cambiado de sitio."
        action={
          <ButtonLink to="/" variant="primary">
            Ir a Inicio
          </ButtonLink>
        }
      />
    </Page>
  );
}

/** Las rutas de la sección 3.1, expuestas aparte para poder recorrerlas en los tests. */
export const routes: RouteObject[] = [
  { path: "/login", element: <Login /> },
  {
    element: <AppShell />,
    children: [
      { path: "/", element: <Home /> },
      { path: "/plantilla", element: <Squad /> },
      { path: "/mercado", element: <Market /> },
      { path: "/jugador/:id", element: <Player /> },
      { path: "/recomendar", element: <Recommend /> },
      { path: "/alineacion", element: <Lineup /> },
      { path: "/ajustes", element: <Settings /> },
      { path: "*", element: <NotFound /> },
    ],
  },
];

export const router = createBrowserRouter(routes);
